import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard'
import CustomSnackbar from './../../shared/custom_snackbar'
import { Button, Grid } from 'semantic-ui-react'
import m from '@utils/strings';

export default class ExameParcialmenteAutorizado extends Component {

    onCopy = () => {
        this.setState({ copied: true });
    }

    render () {

        let { exameResultado } = this.props;

        return (
            <div>
                <div style={{ marginBottom: 5 }}>
                    <label inline={true} style={{ color: '#FF6D00', fontFamily: 'Work Sans', fontSize: 20, fontWeight: 400, marginLeft: 105, marginTop: 15 }}>
                        {m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_ATENDIMENTO_PARCIALMENTE_AUTORIZADO}
                    </label>
                    <label 
                        inline={true} 
                        style={{ color: '#00885F', fontFamily: 'Source Code Pro', fontSize: 16, fontWeight: 500, marginLeft: 15, marginTop: 15, cursor: 'pointer' }}
                        onClick={this.props.displayAutorizacaoResultTable}
                    >
                        {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_MOSTRAR_DETALHES}
                    </label>
                </div>
                <Grid columns='equal' style={{ marginRight: 365, marginTop: 10}}>
                    <Grid.Column key='1'> 
                        <div className={"div-separador-top-10"} style={{ marginLeft: 115, marginTop: 30 }}>
                            <label id={"label-senha"}>{m.TELA_EXAMES_PROCEDIMENTOS.LABEL_SENHA}</label>
                        </div>
                        <div className={"div-separador-top-10"}>
                            <label id={"label-senha-numero"} style={{ fontFamily: 'Source Code Pro', fontWeight: 700, fontSize: 20, marginLeft: 115 }}>
                                {exameResultado.data.solicitacaoProcedimento.senha}
                            </label>
                            <div className={"div-separador-top-10"} style={{ marginLeft: 115 }}>
                                {<CopyToClipboard text={exameResultado.data.SolicitacaoProcedimento.Senha}
                                    onCopy={this.onCopy}>
                                    <label onClick={this.dispatchSenhaSnackbar} id={"label-copiar"}>{m.TELA_EXAMES_PROCEDIMENTOS.LABEL_COPIAR}</label>
                                </CopyToClipboard>}
                            </div>
                        </div>
                        
                        <CustomSnackbar
                            setClick={click => this.dispatchSenhaSnackbar = click}
                            variant="success"
                            duration={1000}
                            content={m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_COPIAR_SENHA}
                        />
                    </Grid.Column>
                    <Grid.Column key='2' style={{maginLeft: 40}}>
                        <div className={"div-separador-top-10"} style={{  marginTop: 25 }}>
                            <label id={"label-senha"}>{m.TELA_EXAMES_PROCEDIMENTOS.LABEL_GUIA}</label>
                        </div>
                        <div className={"div-separador-top-10"}>
                            <label id={"label-senha-numero"} style={{ fontFamily: 'Source Code Pro', fontWeight: 700, fontSize: 20}}>
                                {exameResultado.data.SolicitacaoProcedimento.NumeroGuiaOperadora}
                            </label>
                            <div className={"div-separador-top-10"}>
                                {<CopyToClipboard text={exameResultado.data.SolicitacaoProcedimento.NumeroGuiaOperadora}
                                    onCopy={this.onCopy}>
                                    <label onClick={this.dispatchGuiaSnackbar} id={"label-copiar"}>{m.TELA_EXAMES_PROCEDIMENTOS.LABEL_COPIAR}</label>
                                </CopyToClipboard>}
                            </div>
                        </div>
                        <div 
                            className={"div-separador-top-10"} 
                            style={{ cursor: 'pointer', marginTop: 15 }}
                            onClick={() => {
                                this.props.fetchGuia(exameResultado.data.SolicitacaoProcedimento.Senha);
                            }}
                        >
                            <div  style={{ color: 'rgb(137, 137, 137)', fontFamily: "Source Code Pro" }}> 
                                <img 
                                    src="../images/print.png" 
                                    alt="Imprimir" 
                                />
                                {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_IMPRIMIR_GUIA}
                            </div>
                        </div>
                        <CustomSnackbar
                            setClick={click => this.dispatchGuiaSnackbar = click}
                            variant="success"
                            duration={1000}
                            content={m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_COPIAR_GUIA}
                        />
                    </Grid.Column>
                </Grid>
                <div className={"div-separador-top-bottom-25"} style={{marginTop: 40}}>
                    <hr className={"hr-class"} style={{marginLeft: 101, marginRight: 458 }} />
                </div>
                <div className={"div-separador-top-10"}>
                    <Button
                        onClick={() => {
                            this.props.resetAllStates();
                        }}
                        className={"btn-default-cemig"}
                        style={{ marginLeft: 105 }}
                        >
                        {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_NOVO_ATENDIMENTO} (ENTER)
                    </Button>
                </div>
                <div className='div-separador-25' />
            </div>
        );
    }
}